import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, Cascader, Spin, Typography, Space, DatePicker } from 'antd';
import { PlusOutlined, LoadingOutlined, DeleteOutlined, FilterOutlined } from '@ant-design/icons';
import { generateUTCDate, generateUTCMidnightDate, convertToDateJSON, convertDateToUserTimezone } from '../Components/Utility'; // Import the utility function
import dayjs from 'dayjs';
import { DateTimeFormat, DateFormat ,FIELD_TYPE_RULES ,BASE_OPERATORS} from '../Components/Constant';
const { Option } = Select;
const { Title } = Typography;


const FiltersDynamic = ({
  fields,
  logic,
  setLogic,
  filters,
  setFilters,
  setValueOperator,
  valueOperator,
  fetchLookupRecordsForExistingFilters,
  fetchLookupRecords,
  lookupOptions,
  heading,
}) => {


  const [isLogicEditable, setIsLogicEditable] = useState(false);

  const [operator, setOperator] = useState('AND');
  const [picklistOptions, setPicklistOptions] = useState({});
  const [loadingLookup, setLoadingLookup] = useState(false);

  useEffect(() => {
    const picklistMap = {};

    filters?.forEach(filter => {
      const selectedField = fields?.find(field => field.name === filter.field);
      if (selectedField && selectedField.type === 'picklist') {
        picklistMap[selectedField.name] = selectedField.picklist_values;
      }
    });

    setPicklistOptions(picklistMap);
  }, [filters, fields]);



  const generateLogic = (filtersArray, operatorType) => {

    const logicstr = filtersArray.map((filter, index) => index + 1).join(` ${operatorType} `);
    return logicstr;
  };


  const handleAddFilter = () => {
    setValueOperator('');
    setFilters([...filters, { len: { field: '', value: '', displayValue: '' } }]);
    setLogic(generateLogic(filters, operator));
  };
  const handleRemoveFilter = (index) => {
    const updatedFilters = [...filters];
    updatedFilters?.splice(index, 1);
    setValueOperator('');
    setFilters(updatedFilters);
    setLogic(generateLogic(updatedFilters, operator));
  };
  const handleValueOpertorChange = (index, value) => {
    const updatedFilters = [...filters];
    updatedFilters[index]["operator"] = value;
    updatedFilters[index]["value"] = '';
    updatedFilters[index]["displayValue"] = '';
    setValueOperator(value);
    setFilters(updatedFilters);
  }
  // Handle value change for flters
  const handleValueChange = (index, value) => {
    const updatedFilters = [...filters];
    if (valueOperator === 'isnull' || valueOperator === 'not_null') {
      updatedFilters[index]["value"] = { [valueOperator]: value };
      updatedFilters[index]["displayValue"] = value;
      updatedFilters[index]["operator"] = valueOperator;
    } else if (valueOperator) {
      updatedFilters[index]["value"] = { [`${valueOperator}`]: value };
      updatedFilters[index]["displayValue"] = value === "CURRENT_USER" ? "Current User" : value;
      updatedFilters[index]["operator"] = valueOperator;
    } else {
      updatedFilters[index]["value"] = value;
      updatedFilters[index]["displayValue"] = value === "CURRENT_USER" ? "Current User" : value;
      updatedFilters[index]["operator"] = '';
    }
    setFilters(updatedFilters);
    setLogic(generateLogic(filters, operator));

  };

  const handleFilterChange = (index, key, value) => {
    const selectedField = fields.find(field => value.includes(field.name));
    if (selectedField && selectedField.type === 'lookup') {
      if (!value[0].endsWith('_id')) {
        value[0] = `${selectedField.name}_id`;
      }
      console.log('value', value);
      setLoadingLookup(true);
      console.log('selectedField', selectedField);
      fetchLookupRecords(selectedField?.parent_object_name) // Pass object name to fetch records
        .finally(() => setLoadingLookup(false));
    }
    if (selectedField && selectedField.type === 'picklist') {
      setPicklistOptions(selectedField?.picklist_values); // Pass object name to fetch records
    }
    const updatedFilters = [...filters];
    updatedFilters[index][key] = value[value.length - 1];

    setFilters(updatedFilters);
    setLogic(generateLogic(filters, operator));
  };


  const handleOperatorChange = (value) => {
    setOperator(value);
    if (value !== 'custom') {
      setLogic(generateLogic(filters, value));
      setIsLogicEditable(false);
    } else {
      setIsLogicEditable(true);
    }

  };

  const isValidParentheses = (logic) => {
    let stack = [];
    for (let char of logic) {
      if (char === '(') {
        stack.push(char);
      } else if (char === ')') {
        if (stack.length === 0) {
          return false; // Unmatched closing parenthesis
        }
        stack.pop(); // Match found, pop the last open parenthesis
      }
    }
    return stack.length === 0; // Ensure all parentheses are closed
  };


  const getOperatorsForType = (type) => {
  const groups = FIELD_TYPE_RULES[type] || ["equality", "nullChecks"];

  return groups.flatMap((g) => BASE_OPERATORS[g]);
};



  return (
    <div style={{ padding: '16px 0' }}>
      <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FilterOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
        <Title level={4} style={{ margin: 0 }}>{heading || "Filters"}</Title>
      </div>

      <div style={{ marginBottom: '16px' }}>
        {filters?.map((filter, index) => (
          <Card
            key={index}
            size="small"
            style={{
              marginBottom: '12px',
              border: '1px solid #f0f0f0',
              borderRadius: '8px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              transition: 'all 0.2s ease',
              overflow: 'hidden'
            }}
            bodyStyle={{ padding: '12px 16px' }}
            hoverable
          >
            <Row gutter={[8, 8]} align="middle" style={{ minWidth: 0 }}>
              <Col xs={24} sm={2} md={2} lg={1} xl={1} style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center', // ✅ aligns vertically with selects
                marginTop: '24px', // ✅ pushes it down to match input boxes below labels
              }}>
                <div
                  style={{
                    width: 'clamp(16px, 3vw, 24px)',
                    height: 'clamp(16px, 3vw, 24px)',
                    borderRadius: '50%',
                    backgroundColor: '#1890ff',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'clamp(8px, 1vw, 12px)',
                    fontWeight: 'bold',
                    flexShrink: 0,
                  }}
                >
                  {index + 1}
                </div>

              </Col>
              <Col xs={24} sm={22} md={7} lg={8} xl={8}>
                <div style={{ marginBottom: '4px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Field</label>
                </div>
                <Cascader
                  placeholder="Select field"
                  value={filter.field}
                  allowClear={false}
                  onChange={(value) => handleFilterChange(index, 'field', value)}
                  style={{ width: '100%' }}
                  size="middle"
                  options={fields?.filter(field => field.type !== 'image').map((field) =>
                    field.type === 'address'
                      ? {
                        label: field.label,
                        value: field.name,
                        children: [
                          { value: `${field.name}.street`, label: 'Street' },
                          { value: `${field.name}.city`, label: 'City' },
                          { value: `${field.name}.state`, label: 'State' },
                          { value: `${field.name}.postalcode`, label: 'Postal Code' },
                          { value: `${field.name}.country`, label: 'Country' },
                        ],
                      }
                      : { value: field.name, label: field.label }
                  )}
                />
              </Col>
              <Col xs={12} sm={11} md={5} lg={5} xl={5}>
                <div style={{ marginBottom: '4px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Operator</label>
                </div>
                <Select
                  placeholder="Select operator"
                  style={{ width: '100%' }}
                  size="middle"
                  onChange={(e) => handleValueOpertorChange(index, e)}
                  value={filter.operator}
                >
                  {getOperatorsForType(
                    fields?.find((f) => f.name === filter.field)?.type
                  ).map((op) => (
                    <Option key={op.value} value={op.value}>{op.label}</Option>
                  ))}
                </Select>

              </Col>
              <Col xs={10} sm={9} md={8} lg={8} xl={8}>
                <div style={{ marginBottom: '4px' }}>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Value</label>
                </div>
                {fields?.find((f) => f.name === filter.field?.replace(/_id$/, ''))?.type === 'lookup' ? (
                  valueOperator === 'isnull' || valueOperator === 'not_null' ? (
                    <Select
                      placeholder="Select value"
                      value={filter.displayValue}
                      style={{ width: '100%' }}
                      size="middle"
                      onChange={(value) => handleValueChange(index, value)}
                    >
                      <Option value={true}>True</Option>
                    </Select>
                  ) : (
                    <Select
                      allowClear
                      placeholder="Select value"
                      value={(() => {
                        if (typeof filter.value === 'object' && filter.value !== null) {
                          const operatorKey = Object.keys(filter.value)[0];
                          return filter.value[operatorKey] === "CURRENT_USER" ? "CURRENT_USER" : filter.displayValue;
                        }
                        return filter.value === "CURRENT_USER" ? "CURRENT_USER" : filter.displayValue;
                      })()}
                      style={{ width: '100%' }}
                      size="middle"
                      onChange={(value) => handleValueChange(index, value)}
                      suffixIcon={loadingLookup ? <Spin indicator={<LoadingOutlined spin />} /> : null}
                    >
                      {fields?.find((f) => f.name === filter.field?.replace(/_id$/, ''))?.parent_object_name === 'User' && (
                        <Option value="CURRENT_USER">Current User</Option>
                      )}
                      {lookupOptions?.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  )
                ) : fields?.find((f) => f.name === filter.field)?.type === 'picklist' ? (
                  <Select
                    allowClear
                    placeholder="Select value"
                    value={filter.displayValue}
                    style={{ width: '100%' }}
                    size="middle"
                    onChange={(value) => handleValueChange(index, value)}
                    options={(picklistOptions[filter.field] || []).map((value) => ({ label: value, value }))}
                  />
                ) : (fields?.find((f) => f.name === filter.field)?.type === 'integer' ||
                  fields?.find((f) => f.name === filter.field)?.type === 'decimal' ||
                  fields?.find((f) => f.name === filter.field)?.type === 'currency') ? (
                  <Input
                    type="number"
                    placeholder="Enter number"
                    value={filter.displayValue}
                    style={{ width: '100%' }}
                    size="middle"
                    onChange={(e) => handleValueChange(index, e.target.value ? Number(e.target.value) : '')}
                  />
                ) : fields?.find((f) => f.name === filter.field)?.type === 'date' ||
                  fields?.find((f) => f.name === filter.field)?.type === 'datetime' ? (
                  <>
                    {/* Select Preset Date Values */}
                    <Select
                      placeholder="Select value"
                      value={filter.displayValue}
                      style={{ width: "100%" }}
                      size="middle"
                      onChange={(value) => {
                        handleValueChange(index, value);
                      }}
                      options={[
                        { label: "Today", value: "TODAY" },
                        { label: "This Month", value: "THIS_MONTH" },
                        { label: "This Year", value: "THIS_YEAR" },
                        { label: "Custom", value: "CUSTOM" },
                      ]}
                    />


                  </>

                  ) : (fields?.find((f) => f.name === filter.field)?.type === 'boolean') ? (
                 
                    <Select
                      value={filter.displayValue?.toString()}   
                      onChange={(v) => handleValueChange(index, v === "true" ? true : false)}
                      style={{ width: '100%' }}

                    >
                      <Option value="true">True</Option>
                      <Option value="false">False</Option>
                    </Select>


                  ) : (
                  <Input
                    placeholder="Enter value"
                    value={filter.displayValue}
                    style={{ width: '100%' }}
                    size="middle"
                    onChange={(e) => handleValueChange(index, e.target.value)}
                  />
                )}
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} xl={2} style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center', // ✅ aligns vertically with selects
                marginTop: '24px', // ✅ pushes it down to match input boxes below labels
              }}>
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => handleRemoveFilter(index)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '32px',
                    borderRadius: '6px',
                    minWidth: '32px'
                  }}
                  title="Remove filter"
                />
              </Col>
            </Row>
          </Card>
        ))}
      </div>

      <Button
        type="dashed"
        onClick={handleAddFilter}
        block
        icon={<PlusOutlined />}
        style={{
          marginBottom: '20px',
          height: '40px',
          borderRadius: '8px',
          borderStyle: 'dashed',
          borderWidth: '2px'
        }}
      >
        Add Filter
      </Button>

      {filters?.length > 1 && (
        <Card
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>Logic Configuration</span>
            </div>
          }
          style={{
            marginTop: '16px',
            borderRadius: '8px',
            border: '1px solid #e6f7ff'
          }}
          bodyStyle={{ padding: '16px' }}
        >
          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            <Form.Item
              label="Operator"
              style={{ marginBottom: '12px' }}
              labelCol={{ style: { fontWeight: '500' } }}
            >
              <Select
                defaultValue="AND"
                onChange={handleOperatorChange}
                style={{ width: '200px' }}
                size="middle"
              >
                <Option value="AND">AND</Option>
                <Option value="OR">OR</Option>
                <Option value="custom">Custom</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Logic Expression"
              style={{ marginBottom: 0 }}
              labelCol={{ style: { fontWeight: '500' } }}
            >
              <Input
                defaultValue={logic}
                value={logic}
                onChange={(e) => setLogic(e.target.value)}
                disabled={!isLogicEditable}
                placeholder="Enter custom logic (e.g., 1 AND (2 OR 3))"
                style={{ fontFamily: 'monospace' }}
                size="middle"
              />
            </Form.Item>
          </Space>
        </Card>
      )}
    </div>
  );

}

export default FiltersDynamic;